module.exports = class ProductImage {
  get styleObj() {
    return {
      'background-image': `url(${this.url})`
    };
  }
};
